import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from "../common/Button";
import { Modal } from "semantic-ui-react";

class Confirm extends Component {
    constructor(props) {
        super(props);
        this.confirm = this.confirm.bind(this);
        this.cancel = this.cancel.bind(this);

        this.state = {
            hidden: false
        };
    }

    componentWillReceiveProps() {
        this.setState({ hidden: false });
    }

    confirm() {
        this.props.callback(true);
        this.setState({ hidden: true });
    }

    cancel() {
        this.props.callback(false);
        this.setState({ hidden: true });
    }

    render() {
        const { message } = this.props;
        const titleElement = <h2>Opgelet: niet bewaarde wijzigingen!</h2>;
        const showOnTop = this.props.hookToTop;

        const scrollYSize = window.parent.scrollY;
        let top = 0;
        const confirmHeight = 220;
        const headerHeight = 314;

        if (!showOnTop) {
            if (window.innerHeight === window.parent.innerHeight) {
                // lokaal
                top = ((window.innerHeight + confirmHeight) / 2);
            }
            else {
                const x = headerHeight - scrollYSize + (confirmHeight / 2);
                top = window.parent.innerHeight / 2 - x;
                top = top > (window.innerHeight - confirmHeight * 2) ? window.innerHeight - confirmHeight * 2 : top;
                top = top < (confirmHeight / 2) ? (confirmHeight / 2) : top;
            }
        }
        else {
            top = 10;
        }

        window.parent.scrollTo(0, top);

        const style = { bottom: 'auto', top: top };

        return (
            <Modal
                style={style}
                open={!this.state.hidden}>
                <Modal.Content>
                    {titleElement}
                    <div>{message}</div>
                </Modal.Content>
                <Modal.Actions className={"c-form__actions"}>
                    <Button autoFocus onClick={this.cancel} text="Terug" /><Button onClick={this.confirm} text="Ga verder" />
                </Modal.Actions>
            </Modal>);
    }
}

Confirm.propTypes = {
    message: PropTypes.string,
    callback: PropTypes.func,
    hookToTop: PropTypes.bool
};

export default Confirm;